import styled from '@emotion/styled';
import { everything } from '@otovo/rainbow';

const Box = styled.div`
  ${everything}
`;

export default Box;
